export const appKeyEnum = {
  YCP_APP_KEY: 'sRCMIo2LGCX281KpJyKnU05K' // 羊城派APPkey
}

export const ossUploadType = {
  commonImage: 0, // 通用图片
  themeImage: 1, // 主题图片
  splashFile: 2, // 开屏页文件(可以是图片或MP4)
  avatarFile: 3, // 头像文件
  apkFile: 20, // apk文件
  otherDoc: 50 // 其他文件
}

//主题类型；0 - APP主题设置，1 - 栏目主题设置
export const AppThemeObjectType = {
  APP: 0,
  COLUMN: 1
}

// app客户端类型 ；1 - 安卓，2 - IOS，3 - 鸿蒙
export const appClientPlatform = {
  // 数值对应后端存储的platform值（与后端协商一致）
  ANDROID: { value: 1, label: '安卓', key: 'android' },
  IOS: { value: 2, label: 'IOS', key: 'ios' },
  HARMONYOS: { value: 3, label: '鸿蒙', key: 'harmonyos' }
}

//app客户端类型转换为数组，方便下拉框/列表渲染
export const appClientPlatformList = Object.values(appClientPlatform)

export const agreementTypeEnum = {
  user_url: 20, // 用户协议文件链接(htm/html)
  private_policy_url: 22, // 隐私政策文件链接(htm/html)
  private_summary_url: 24, // 隐私摘要文件链接(htm/html)
  third_party_share_url: 26, // 第三方共享清单文件链接(htm/html)
  logout_ag_url: 28, // 注销协议文件链接(htm/html)
  app_permission_url: 31, // APP权限文件链接(htm/html)
  psn_info_collect_url: 35 // 个人信息收集清单文件链接(htm/html)
}
